package com.banyan.flightviewer.util

actual fun nowMs(): Long = kotlin.js.Date.now().toLong()
